import * as React from 'react'
import { Col, Row } from 'reactstrap'
import ProductCard from '../../components/shared/Store/ProductCard/ProductCard'
import Product from 'api/models/Product'
import Store, { Category } from 'api/models/Store'
import Cart from 'api/models/Cart'
import TagHeader from '../../components/layout/TagHeader/TagHeader'

interface Props {
  activeStore: Store
  cart: Cart
  onProductClick: (product: Product) => void
  onRemoveFromCart: (product: Product) => void
  onAddToCart: (product: Product) => void
}

export default function StoreViewProducts({ activeStore, cart, onProductClick, onRemoveFromCart, onAddToCart }: Props) {
  const hasCategories = activeStore.countCategories() > 0
  const tagHeader = (category: Category) => {
    if (hasCategories && category.products.length && category.name) {
      const params = { name: category.name.toUpperCase() }
      return <TagHeader {...params} />
    }
    return undefined
  }

  return (
    <Row>
      <Col xs={{ size: '12' }} sm={{ size: 10, offset: 1 }} lg={{ size: 10, offset: 1 }} xl={{ size: 8, offset: 2 }}>
        {activeStore.getSortedCategories().map((category: Category, categoryIndex) => {
          return (
            <div key={`category-${categoryIndex}`}>
              {tagHeader(category)}
              <Row>
                {category.products.flatMap((item: Product, productIndex) => {
                  const productId = item.getId() || 'fakeprod'
                  return (
                    <Col
                      xs="6"
                      sm="4"
                      md="3"
                      xl="3"
                      className="mb-2 p-1 p-sm-2 p-md-2"
                      key={`product-column-${productIndex}`}
                    >
                      <ProductCard
                        test={false}
                        key={productId}
                        showLowStock={activeStore.showLowStock()}
                        storeId={activeStore.getShortId()}
                        index={productIndex}
                        productInCart={cart.getProduct(productId)}
                        removeFromCart={onRemoveFromCart}
                        addToCart={onAddToCart}
                        isActive={activeStore.isInsideGeo()}
                        product={item}
                        activeStore={activeStore}
                        onToggle={onProductClick}
                      />
                    </Col>
                  )
                })}
              </Row>
            </div>
          )
        })}
      </Col>
    </Row>
  )
}
